export const STATIC_PRESETS_NAMES = ["feed"];
export const LOCAL_PRESETS_KEY = "presets-order";
export const LOCAL_STATIC_PRESETS_KEY = "static-presets-order";

// Static preset IDs used to identify non-backend presets
export const STATIC_PRESET_IDS = [
  "11111111-1111-1111-1111-111111111111", // Feed preset
  "22222222-2222-2222-2222-222222222222", // Deleted preset
  "33333333-3333-3333-3333-333333333333", // Correlated preset
  "44444444-4444-4444-4444-444444444444", // Without correlation preset
];
